import { styled } from 'styled-components'
import { Link } from 'react-router'

export const RouteLink = styled(Link)`
  text-decoration: none;
  color: unset;
`
